export class MechanicImportModel {
    counter: number = 0;
    branchCode: number = 0;
    typeDocumentId: number = 0;
    documents: string = "";
    digitVerification: number = 0;
    name: string = "";
    address: string | null = null;
    phone: string | null = null;
    alterPhone: string | null = null;
    contact: string | null = null;
    active: boolean = false;
    swExternal: boolean = false;

    constructor(counter: number,
        branchCode: number,
        typeDocumentId: number,
        documents: string,
        digitVerification: number,
        name: string,
        address: string | null,
        phone: string | null,
        alterPhone: string | null,
        contact: string | null,
        active: boolean,
        swExternal: boolean
    ) {
        this.counter = counter;
        this.branchCode = branchCode;
        this.typeDocumentId = typeDocumentId;
        this.documents = documents;
        this.digitVerification = digitVerification;
        this.name = name;
        this.address = address;
        this.phone = phone;
        this.alterPhone = alterPhone;
        this.contact = contact;
        this.active = active;
        this.swExternal = swExternal;
    }
}